/* eslint-disable camelcase */
const checkoutOptionModel = function googleAnalyticsCheckoutOptionModel(
  step,
  option,
) {
  return {
    event: 'checkoutOption',
    ecommerce: {
      checkout_option: {
        actionField: { step, option },
      },
    },
  };
};

export default checkoutOptionModel;
